const { Core, Utils, Events } = Global;
const { $show, $hide } = Utils;

customElements.define('browsing-history-slider', class extends Core {
    elements = {
        slider: 'slideshow-inline-blaze'
    }

    render() {
        this.sub(Events.BROWSING_HISTORY_LOAD, this._handleHistoryLoad);
    }

    _handleHistoryLoad({ items, error }) {
        this.items = [];
        if(error || !items || items.length === 0) {
            this._clearSlider();
            $hide(this);
            return;
        }

        this.items = items;
        customElements.whenDefined(this.elements.slider)
            .then(this._updateSlider.bind(this))
    }

    _updateSlider() {
        if(!this.items.length) return;
        $show(this);
        this.$('slider').replaceSlides(this.items);
    }

    _clearSlider() {
        const slider = this.$('slider');
        if(!slider) return;

        if(slider.slider) {
            slider.destroy();
            slider.slider = null;
        }
        slider.querySelector('[data-slides-wrapper]')?.replaceChildren();
        slider.setAttribute('inert', '');
    }
})
